
import Hero from './EntryPage';
import {useState, useEffect} from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { useGenericEffect } from '../components/UseGenericEffect';
import UnderConstruction from '../components/UnderConstruction';
import { useAuditLogger } from '../hooks/UseAuditLogger.js';





export default function PastEvents() {
  const { strings } = useLanguage();
  const { logEvent } = useAuditLogger();
    useEffect(() => {
         // Audit record selection
        logEvent({
          eventType: 'page.view',
          action: 'READ',
          requestData: { pageName: "Pffectast events" }
        });
      }, []);

  const map = {
  };  
  const [message, setMessage] = useState('');
  return (
    <div className="main">
       <UnderConstruction />   
    </div>
  );
}
